// IndexedDB structured cloning preserves File/Blob bytes, unlike localStorage.
// Writes are ordered per draft so a slow save cannot resurrect a consumed draft.
const queues = new Map();
function openDatabase() {
  return new Promise((resolve, reject) => {
    if (!globalThis.indexedDB) return reject(new Error('Armazenamento de anexos indisponível'));
    const request = indexedDB.open('apolo-drafts-v2', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('attachments');
    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);
  });
}
async function transaction(key, value, write) {
  const db = await openDatabase();
  try {
    return await new Promise((resolve, reject) => {
      const tx = db.transaction('attachments', write ? 'readwrite' : 'readonly');
      const store = tx.objectStore('attachments');
      const request = write ? (value == null ? store.delete(key) : store.put(value, key)) : store.get(key);
      tx.oncomplete = () => resolve(request.result || []);
      tx.onerror = () => reject(tx.error);
      tx.onabort = () => reject(tx.error || new Error('Falha ao salvar anexos'));
    });
  } finally { db.close(); }
}
export function saveAttachmentDraft(key, attachments) {
  const next = (queues.get(key) || Promise.resolve()).catch(() => {}).then(() => transaction(key, attachments.length ? attachments : null, true));
  queues.set(key, next);
  next.finally(() => { if (queues.get(key) === next) queues.delete(key); }).catch(() => {});
  return next;
}
export async function loadAttachmentDraft(key) {
  await queues.get(key)?.catch(() => {});
  return transaction(key, undefined, false);
}
